module.exports = __webpack_public_path__ + "img/uri_dog.f3cc6160.jpg";